import React, { useEffect, useState } from 'react';
import TableWrapper from './TableWrapper';
import RowTable from './RowTable';
import { useDispatch, useSelector } from 'react-redux';
import { getDocument, userSelector } from '../../services/reduxSlices/UserSlice';

/**
 * Composant présent sur la boite de réception 
 * Tableau contenant les documents
 * 
 * @returns ListdocSignTable
 */
const ListdocSignTable = () => {
	
	const [fromDate ,setFromDate] = useState('2023-08-03')
	const [toDate ,setToDate] = useState('2023-08-03')

	const [page, setPage] = useState(1)
	const dispatch = useDispatch()
	
	useEffect(() => {
		const data = {
			page,
			start: undefined,
			end: undefined
		}
		dispatch(getDocument(data))
	},[page])

	const onApplyDateFilter = () =>{
		const data = {
			page: undefined,
			start: fromDate,
			end: toDate,
			search: undefined,
		}
		dispatch(getDocument(data))
    }

	const onApplySearch = (e) =>{
		e.preventDefault()
		const { value } = e.target

		const data = {
			page: undefined,
			start: undefined,
			end: undefined,
			search: value
		}
		dispatch(getDocument(data))
    }
	
	const { signDocuments } = useSelector(userSelector)

    return(
		<TableWrapper onApplySearch={onApplySearch} onApplyDateFilter={onApplyDateFilter} setFromDate={setFromDate} setToDate={setToDate} setPage={setPage} currentPage={page} maxPage={signDocuments.data ? signDocuments.meta.last_page : 0}>
			{
				signDocuments.data && signDocuments.data.map((rw)=>{
					return <RowTable data={rw} />
				})
			}
		</TableWrapper>
    );
}

export default ListdocSignTable;